/** Escape HTML special characters to prevent XSS when injecting into innerHTML */
export function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/**
 * Redirect method to be able to stub the redirect in end to end tests
 *
 * @param {string} url
 */
export const redirect = (url) => {
    window.location.href = url;
};
window.redirect = redirect;
export function hideOnClickOutside(element) {
    const outsideClickListener = (event) => {
        if (!element.contains(event.target)) {
            element.classList.add('u-hidden');
        }
    };
    document.addEventListener('click', outsideClickListener);
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            element.classList.add('u-hidden');
        }
    });
}
export const isWebview = () => {
    return navigator.userAgent.startsWith('app-');
};
export const getSite = () => {
    return window.location.pathname.split('/')[1];
};
// From https://stackoverflow.com/a/47614491
export const setHTMLWithScripts = function (elm, html, mode = 'inner', selector) {
    if (mode === 'outer' && !selector) {
        throw new Error('Selector is required when using outer mode');
    }
    if (mode === 'outer') {
        elm.outerHTML = html;
    }
    else {
        elm.innerHTML = html;
    }
    // Needs to re-query element since the reference might have changed in case of outerHTML
    const replacedElm = mode === 'outer' ? document.querySelector(selector) : elm;
    Array.from(replacedElm.querySelectorAll('script')).forEach((oldScript) => {
        eval(oldScript.innerHTML);
    });
};
